import type { Event } from "../../api/events/Event.typed";
import { calendarDateFromIsoUtc, todayUtcCalendarDateKey } from "./eventDateHelpers";

export type EventLifeStatus = "upcoming" | "ongoing" | "past";

export function eventLifeStatus(event: Event): EventLifeStatus {
  const today = todayUtcCalendarDateKey();
  const startKey = calendarDateFromIsoUtc(event.start_date);
  const endKey = calendarDateFromIsoUtc(event.end_date);

  if (today < startKey) return "upcoming";
  if (today <= endKey) return "ongoing";

  return "past";
}

export function eventStatusLabel(status: EventLifeStatus): string {
  switch (status) {
    case "upcoming":
      return "À venir";
    case "ongoing":
      return "En cours";
    case "past":
      return "Terminé";
  }
}

export function eventStatusColor(status: EventLifeStatus): "primary" | "success" | "neutral" {
  switch (status) {
    case "upcoming":
      return "primary";
    case "ongoing":
      return "success";
    case "past":
      return "neutral";
  }
}
